const sigma = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.35 3.787A1.1 1.1 0 0 1 4.209 2H12v2H6.081l2.65 3.313a1.1 1.1 0 0 1 0 1.374L6.081 12h5.92v2H4.208a1.1 1.1 0 0 1-.86-1.787L6.72 8z" clip-rule="evenodd"/></svg>',
};

export { sigma as default };
